import React, { Component } from "react";

import PropTypes from "prop-types";

import { BrowserRouter, Switch, Route } from "react-router-dom";

import TopBar from "../layout/TopBar";

import Assignments from "../pages/Assignments";
import Report from "../pages/Report";
import NotFoundPage from "../pages/NotFoundPage";

// USUARIOS ----------------->
// import UserPage from "../UserPage";
//<----------------- USUARIOS

class Router extends Component {
  render() {
    return (
      <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
        <TopBar />
        <div style={{ margin: "0 10px" }}>
          <Switch>
            <Route path="/" exact>
              <Assignments />
            </Route>
            <Route path="/report/:reportId">
              <Report />
            </Route>

            <Route>
              <NotFoundPage />
            </Route>
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

Router.propTypes = {
  // Properties
  user: PropTypes.object,
};

export default Router;
